import React, { useEffect, useState } from "react";
import "../../styles/plano-texas.css";
import "../../styles/doyles-town.css";

export const LeadingClinicForm = ({ cidValue, redirectionUrl }: { cidValue: string, redirectionUrl: string }) => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Guard for SSR
    if (typeof window === "undefined") return;

    const form = document.getElementById("lead-gen-form-1") as HTMLFormElement | null;

    const getQueryParams = () => {
      const params = new URLSearchParams(window.location.search);
      const responses: { question: string; response: string }[] = [];

      params.forEach((value, key) => {
        responses.push({ question: key, response: value });
      });

      return responses;
    };

    const abortController = new AbortController();

    const handleSubmit = (e: Event) => {
      e.preventDefault();
      if (!form || loading) return;

      setLoading(true);
      document.body.style.overflow = "hidden";

      const formData: Record<string, any> = {};

      form.querySelectorAll<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>("input, select, textarea").forEach((field) => {
        const { name, value } = field;
        if (name && value) {
          formData[name] = value;
        }
      });

      formData.responses = getQueryParams();

      fetch("https://us-central1-ys-private-web-apps.cloudfunctions.net/formSubmit", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      })
        .then(async (response) => {
          if (response.ok) {
            window.location.href = redirectionUrl;
          } else {
            const errorData = await response.json();
            console.error("Form submission error:", errorData);
            alert(errorData.message || "Form submission failed");
          }
        })
        .catch((error: any) => {
          console.error("Form submission error:", error);
          alert(error.message || "Something went wrong. Please try again.");
          setLoading(false);
          document.body.style.overflow = "auto";
        });
    };

    if (form) form.addEventListener("submit", handleSubmit);

    return () => {
      if (form) form.removeEventListener("submit", handleSubmit);
      document.body.style.overflow = "auto";
      abortController.abort();
    };
  }, [redirectionUrl]);

  return (
    <div className="leading-clinic-form-container w-full backdrop-blur-lg rounded-lg p-6 md:p-[2.6rem]">
      <h2 className="text-xl font-bold text-gray-800 mb-6">
        <span className="leading-clinic-form-heading">
          Fill out the form below to connect with a hearing specialist near you and schedule your appointment today!
        </span>
      </h2>

      <form id="lead-gen-form-1" className="space-y-4">
        <input id="cid" name="cid" type="hidden" value={cidValue} readOnly className="hidden" />
        <div className="form-input-div w-full flex flex-col">
          <input type="text" name="firstName" placeholder="First Name*" required className="leading-clinic-form-input" />
          <input type="text" name="lastName" placeholder="Last Name*" required className="leading-clinic-form-input" />
          <input type="tel" name="number" placeholder="Phone Number" className="leading-clinic-form-input" />
          <input type="email" name="email" placeholder="Email*" required className="leading-clinic-form-input" />
          <input type="text" name="postalCode" placeholder="Zip Code*" required className="leading-clinic-form-input" />
          <button type="submit" disabled={loading} className="book-now-button-lcf w-full py-3 bg-blue-600 text-white font-semibold rounded-full hover:bg-blue-700 transition disabled:opacity-50">
            {loading ? (
              <span className="flex items-center justify-center">
                <svg className="animate-spin h-5 w-5 mr-2 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.4 0 0 5.4 0 12h4z" />
                </svg>
                Submitting...
              </span>
            ) : (
              "Book Now"
            )}
          </button>
        </div>
      </form>

      <p className="text-xs text-gray-500 mt-4">
        By clicking the button, you consent for Yes Hearing and its affiliates to use automated technology — including calls, texts and prerecorded messages — to contact you at the number and email provided about Yes Hearing offers. This consent is not required to make a purchase.
      </p>

      {loading && (
        <div className="fixed inset-0 bg-white bg-opacity-70 z-50 flex items-center justify-center">
          <svg className="animate-spin h-12 w-12 text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.4 0 0 5.4 0 12h4z" />
          </svg>
        </div>
      )}
    </div>
  );
};
